// Website-wide JS (all portal/website pages, not desk).

// Session expired: send the user to login instead of Frappe's "Method Not
// Allowed" modal. Only HTTP 401, or a Guest PermissionError. Never scan the
// body of a successful response — a ticket or post can contain those phrases.
(function () {
	if (window.location.pathname === "/login") return;

	var redirecting = false;

	function cookieUserId() {
		var m = document.cookie.match(/(?:^|; )user_id=([^;]*)/);
		return m ? decodeURIComponent(m[1]) : "";
	}

	function isGuest() {
		var uid = cookieUserId();
		var sessionUser =
			(window.frappe && frappe.session && frappe.session.user) || "";
		return uid === "Guest" || sessionUser === "Guest";
	}

	function parseJson(xhr) {
		if (!xhr) return null;
		if (xhr.responseJSON) return xhr.responseJSON;
		try {
			return JSON.parse(xhr.responseText || "");
		} catch (e) {
			return null;
		}
	}

	function isLoginRequiredXhr(xhr) {
		if (!xhr) return false;
		if (xhr.status === 401) return true;
		if (xhr.status !== 403 && xhr.status !== 417) return false;
		var data = parseJson(xhr);
		if (!data) return false;
		var exc = String(data.exc_type || data.exception || "");
		if (exc.indexOf("AuthenticationError") !== -1) return true;
		// Guest hitting a login-required whitelist method. A logged-in user's
		// real PermissionError must not log them out.
		return exc.indexOf("PermissionError") !== -1 && isGuest();
	}

	function isGuestPermissionModal(payload) {
		if (!isGuest()) return false;
		var title = "";
		var message = "";
		if (payload && typeof payload === "object") {
			title = String(payload.title || "");
			message = String(payload.message || payload._error_message || "");
		} else {
			message = String(payload || "");
		}
		var t = (title + " " + message).toLowerCase();
		return (
			t.indexOf("method not allowed") !== -1 ||
			t.indexOf("login to access") !== -1
		);
	}

	function goLogin() {
		if (redirecting) return;
		redirecting = true;
		try {
			if (window.frappe && frappe.hide_msgprint) frappe.hide_msgprint();
		} catch (e) {}
		try {
			document.querySelectorAll(".modal, .msgprint-dialog").forEach(function (el) {
				el.style.display = "none";
			});
		} catch (e) {}
		var next =
			window.location.pathname + window.location.search + window.location.hash;
		if (!next || next === "/") next = "/launchpad";
		window.location.href =
			"/login?redirect-to=" + encodeURIComponent(next);
	}

	function stripHtml(html) {
		var d = document.createElement("div");
		d.innerHTML = String(html || "");
		return (d.textContent || d.innerText || "").replace(/\s+/g, " ").trim();
	}

	function messageText(payload) {
		if (payload == null) return "";
		if (typeof payload === "string") return stripHtml(payload);
		if (typeof payload === "object") {
			var m = payload.message || payload._error_message || "";
			if (Array.isArray(m)) m = m.map(messageText).filter(Boolean).join(" ");
			return stripHtml(m);
		}
		return stripHtml(String(payload));
	}

	var lastPortalMsg = "";
	function showPortalError(text) {
		if (!text) return;
		if (text === lastPortalMsg) return;
		var generic = /^(not permitted|not allowed|error|message)$/i.test(text);
		if (generic && lastPortalMsg) return;
		lastPortalMsg = text;
		var open =
			document.querySelector(".cs-modal-back:not([hidden])") ||
			document.querySelector(".cs-tm-modal:not([hidden])") ||
			document.querySelector("#ann-modal.open, #art-modal:not(.hide), #art-read:not(.hide), #tpl-modal:not(.hide), #pl-metrics-modal.open, #pl-metrics-modal:not(.hide), #pl-modal.open, #pl-modal:not(.hide), .cs-dlg-back");
		if (open) {
			var slot =
				open.querySelector(".cs-modal-err, .cs-tm-err, #csTmErr") ||
				null;
			if (!slot) {
				slot = document.createElement("p");
				slot.className = "cs-modal-err";
				var body = open.querySelector(".cs-modal-body, .cs-tm-modal-card, .modal-body");
				if (body) body.insertBefore(slot, body.firstChild);
			}
			if (slot) {
				slot.hidden = false;
				slot.textContent = text;
				return;
			}
		}
		if (window.frappe && frappe.show_alert) {
			frappe.show_alert({ message: text, indicator: "red" });
		}
	}

	function hideFrappeMessageDialogs() {
		try {
			if (window.frappe && frappe.hide_msgprint) frappe.hide_msgprint();
		} catch (e) {}
		document.querySelectorAll(".msgprint-dialog, .modal.msgprint").forEach(function (el) {
			el.remove();
		});
	}

	function isPortalPage() {
		return !!(document.body && document.body.classList.contains("cs-portal"));
	}

	function patchMsgprint() {
		if (!window.frappe || typeof frappe.msgprint !== "function") return false;
		if (frappe.msgprint._csSessionPatched) return true;
		var orig = frappe.msgprint.bind(frappe);
		frappe.msgprint = function (msg, title) {
			var payload = msg;
			if (title && (typeof msg === "string" || !msg)) {
				payload = { message: msg, title: title };
			}
			if (isGuestPermissionModal(payload)) {
				goLogin();
				return;
			}
			if (isPortalPage()) {
				if (payload && typeof payload === "object" && payload.alert) {
					return orig.apply(null, arguments);
				}
				showPortalError(messageText(payload));
				hideFrappeMessageDialogs();
				return;
			}
			return orig.apply(null, arguments);
		};
		frappe.msgprint._csSessionPatched = true;
		return true;
	}

	function wireAjax() {
		if (!window.jQuery || window.jQuery._csSessionAjax) return;
		window.jQuery._csSessionAjax = true;
		jQuery(document).ajaxError(function (_e, xhr) {
			if (isLoginRequiredXhr(xhr)) goLogin();
		});
	}

	function boot() {
		patchMsgprint();
		wireAjax();
		if (document.body) {
			var obs = new MutationObserver(function () {
				if (!isPortalPage()) return;
				document.querySelectorAll(".msgprint-dialog").forEach(function (el) {
					var body = el.querySelector(".modal-body, .msgprint");
					var text = stripHtml(body ? body.innerHTML : el.textContent);
					if (text) showPortalError(text);
					el.remove();
				});
			});
			obs.observe(document.body, { childList: true, subtree: true });
		}
		var n = 0;
		var id = setInterval(function () {
			if (patchMsgprint() || ++n > 40) clearInterval(id);
		}, 50);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", boot);
	} else {
		boot();
	}
})();

// Land on /launchpad after login. Frappe's server-side post-login redirect
// depends on user_type / default_app / allowed workspaces (System Users get
// /app or /apps, Website Users get portal home), but a `redirect-to` URL arg
// wins in every branch of login.js - so pin it on the login page.
(function () {
	if (window.location.pathname !== "/login") return;
	var params = new URLSearchParams(window.location.search);
	if (params.get("redirect-to")) return;
	params.set("redirect-to", "/launchpad");
	history.replaceState(
		null,
		"",
		window.location.pathname + "?" + params.toString() + window.location.hash
	);
})();

// Login: Frappe only turns the fields red and puts the error on the Login
// button ("Invalid Login. Try again."), which is easy to miss. Show a clear
// message under the form instead.
(function () {
	if (window.location.pathname !== "/login") return;

	var LOGIN_LABEL = "Login";
	var CREDENTIALS_ERROR = "Invalid username or invalid password.";

	function ensureErrorEl() {
		var existing = document.getElementById("cs-login-error");
		if (existing) return existing;
		var actions =
			document.querySelector(".for-login .page-card-actions") ||
			document.querySelector(".page-card-actions");
		var el = document.createElement("div");
		el.id = "cs-login-error";
		el.className = "cs-login-error";
		el.setAttribute("role", "alert");
		el.hidden = true;
		if (actions && actions.parentNode) {
			actions.parentNode.insertBefore(el, actions);
		} else {
			var body = document.querySelector(".for-login .page-card-body");
			if (body) body.appendChild(el);
		}
		return document.getElementById("cs-login-error");
	}

	function friendlyMessage(raw) {
		var text = String(raw || "");
		var low = text.toLowerCase();
		if (
			!text
			|| low.indexOf("invalid login") !== -1
			|| low.indexOf("invalid credentials") !== -1
			|| low.indexOf("authentication") !== -1
			|| low.indexOf("incorrect") !== -1
		) {
			return CREDENTIALS_ERROR;
		}
		return text;
	}

	function restoreLoginButton() {
		document.querySelectorAll(".for-login .btn-login, .btn-primary.btn-login").forEach(function (btn) {
			var label = btn.getAttribute("data-cs-login-label");
			if (!label) {
				label = LOGIN_LABEL;
				if (typeof __ === "function") {
					try { label = __("Login") || LOGIN_LABEL; } catch (e) {}
				}
			}
			btn.textContent = label;
			btn.disabled = false;
		});
	}

	function showLoginError(message) {
		try {
			var el = ensureErrorEl();
			if (el) {
				el.textContent = friendlyMessage(message);
				el.hidden = false;
			}
		} catch (e) {}
		restoreLoginButton();
		try {
			if (window.frappe && frappe.unfreeze) frappe.unfreeze();
		} catch (e) {}
	}

	function hideLoginError() {
		var el = document.getElementById("cs-login-error");
		if (el) {
			el.hidden = true;
			el.textContent = "";
		}
		document.querySelectorAll(".page-card-body.invalid").forEach(function (node) {
			node.classList.remove("invalid");
		});
	}

	function rememberLoginButtons() {
		document.querySelectorAll(".btn-login").forEach(function (btn) {
			if (btn.getAttribute("data-cs-login-label")) return;
			var label = (btn.textContent || "").trim();
			if (!label || /^verifying/i.test(label) || /^invalid/i.test(label)) return;
			btn.setAttribute("data-cs-login-label", label);
		});
	}

	function patchLogin() {
		if (!window.login || login._csErrorPatched) return !!window.login;
		login._csErrorPatched = true;
		rememberLoginButtons();

		var origInvalid = login.set_invalid.bind(login);
		var origStatus = login.set_status.bind(login);

		login.set_status = function (message, color) {
			try {
				origStatus(message, color);
			} catch (e) {}
			if (color === "red") showLoginError(message);
		};

		login.set_invalid = function (message) {
			try {
				origInvalid(message);
			} catch (e) {}
			showLoginError(message);
		};

		["#login_email", "#login_password"].forEach(function (sel) {
			var input = document.querySelector(sel);
			if (!input) return;
			input.addEventListener("input", hideLoginError);
		});
		var form = document.querySelector(".for-login .form-login");
		if (form) {
			form.addEventListener("submit", function () {
				hideLoginError();
				rememberLoginButtons();
			});
		}
		return true;
	}

	if (window.jQuery) {
		$(document).on("login_rendered", patchLogin);
	}
	function tryPatch() {
		if (patchLogin()) return;
		var n = 0;
		var id = setInterval(function () {
			if (patchLogin() || ++n > 40) clearInterval(id);
		}, 50);
	}
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", tryPatch);
	} else {
		tryPatch();
	}
})();

// /update-password - show/hide toggles (same behaviour as login page).
(function () {
	if (!/\/update-password\/?$/.test(window.location.pathname)) return;

	function toggleLabel(show) {
		if (typeof __ === "function") return __(show ? "Show" : "Hide");
		return show ? "Show" : "Hide";
	}

	function bindToggle(toggle, input) {
		toggle.addEventListener("click", function () {
			var reveal = input.type === "password";
			input.type = reveal ? "text" : "password";
			toggle.textContent = toggleLabel(!reveal);
		});
	}

	function initResetPasswordToggles() {
		["#old_password", "#new_password", "#confirm_password"].forEach(function (sel) {
			var input = document.querySelector(sel);
			if (!input || input.closest(".password-field")) return;

			var wrap = document.createElement("div");
			wrap.className = "password-field";
			input.parentNode.insertBefore(wrap, input);
			wrap.appendChild(input);

			var toggle = document.createElement("span");
			toggle.className = "toggle-password text-muted";
			toggle.textContent = toggleLabel(true);
			wrap.appendChild(toggle);
			bindToggle(toggle, input);
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initResetPasswordToggles);
	} else {
		initResetPasswordToggles();
	}
})();
/**
 * Shared portal helpers for employee dropdown rows (initials avatar + name).
 * Desk Link fields are handled separately in cs_desk.bundle.js.
 */
(function (global) {
  var PALETTES = [
    ["#DBEAFE", "#1D4ED8"],
    ["#EDE9FE", "#6D28D9"],
    ["#E0E7FF", "#4338CA"],
    ["#F3E8FF", "#7E22CE"],
    ["#E0F2FE", "#0369A1"],
    ["#EDE9FE", "#5B21B6"],
  ];

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function initials(name) {
    var parts = String(name || "")
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) return "?";
    return (
      parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : "")
    ).toUpperCase();
  }

  function palette(name) {
    var h = 0;
    var s = String(name || "");
    for (var i = 0; i < s.length; i++) h = (h + s.charCodeAt(i) * 17) % PALETTES.length;
    return PALETTES[h];
  }

  function avatarHtml(name, image) {
    if (image) {
      return (
        '<span class="cs-emp-opt-av" aria-hidden="true"><img src="' +
        escapeHtml(image) +
        '" alt=""></span>'
      );
    }
    var pal = palette(name);
    return (
      '<span class="cs-emp-opt-av" style="background:' +
      pal[0] +
      ";color:" +
      pal[1] +
      '" aria-hidden="true">' +
      escapeHtml(initials(name)) +
      "</span>"
    );
  }

  function optionHtml(emp) {
    var name = (emp && (emp.employee_name || emp.full_name || emp.label || emp.name)) || "";
    var id = (emp && (emp.name || emp.value || emp.id)) || "";
    return (
      '<button type="button" class="cs-emp-opt" data-emp="' +
      escapeHtml(id) +
      '" data-emp-name="' +
      escapeHtml(name) +
      '">' +
      avatarHtml(name, emp && emp.image) +
      '<span class="cs-emp-opt-name">' +
      escapeHtml(name) +
      "</span></button>"
    );
  }

  global.CsEmployeePicker = {
    initials: initials,
    palette: palette,
    avatarHtml: avatarHtml,
    optionHtml: optionHtml,
    escapeHtml: escapeHtml,
  };
})(window);

// /login - "Login with email link". Frappe answers "Login link sent to your
// email" for every address, including ones with no account (so nobody can probe
// which addresses exist). Left alone, a person HR has not added yet waits for an
// email that was never sent. The note says what actually happens without
// revealing whether this address has an account.
(function () {
	function t(text) {
		return typeof __ === "function" ? __(text) : text;
	}

	function showNote(form) {
		var note = form.parentNode.querySelector(".cs-login-link-note");
		if (!note) {
			note = document.createElement("p");
			note.className = "cs-login-link-note text-muted small";
			note.setAttribute("role", "status");
			note.style.marginTop = "12px";
			form.parentNode.insertBefore(note, form.nextSibling);
		}
		note.textContent = t(
			"If this email belongs to an account, a login link is on its way and works for a few minutes. " +
				"Nothing arrives if HR has not added you yet. Check your spam folder, or ask HR to add you."
		);
	}

	function init() {
		var form = document.querySelector(".form-login-with-email-link");
		if (!form) return;
		form.addEventListener("submit", function () {
			var box = form.querySelector("#login_with_email_link_email");
			if (box && box.value.trim()) showNote(form);
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();

/* The portal's own confirmation dialog, in place of the browser's window.confirm.
 *   csConfirm({ title, message, confirmLabel, cancelLabel, danger }) -> Promise<boolean>
 * Escape, the backdrop and Cancel all answer false. Focus lands on Cancel for a
 * destructive question and on the confirm button otherwise, and goes back to
 * whatever had it when the dialog closes. */
(function (global) {
  var seq = 0;
  global.csConfirm = function (opts) {
    opts = opts || {};
    return new Promise(function (resolve) {
      var id = "cs-dlg-" + ++seq;
      var opener = document.activeElement;
      var back = document.createElement("div");
      back.className = "cs-dlg-back";
      var box = document.createElement("div");
      box.className = "cs-dlg";
      box.setAttribute("role", "alertdialog");
      box.setAttribute("aria-modal", "true");
      box.setAttribute("aria-labelledby", id + "-t");
      box.setAttribute("aria-describedby", id + "-m");
      var title = document.createElement("h2");
      title.id = id + "-t";
      title.className = "cs-dlg-title";
      title.textContent = opts.title || "Are you sure?";
      var msg = document.createElement("p");
      msg.id = id + "-m";
      msg.className = "cs-dlg-msg";
      msg.textContent = opts.message || "";
      var row = document.createElement("div");
      row.className = "cs-dlg-actions";
      var no = document.createElement("button");
      no.type = "button";
      no.className = "cs-dlg-btn";
      no.textContent = opts.cancelLabel || "Cancel";
      var yes = document.createElement("button");
      yes.type = "button";
      yes.className = "cs-dlg-btn cs-dlg-primary" + (opts.danger ? " cs-dlg-danger" : "");
      yes.textContent = opts.confirmLabel || "Confirm";
      row.appendChild(no);
      row.appendChild(yes);
      box.appendChild(title);
      if (opts.message) box.appendChild(msg);
      box.appendChild(row);
      back.appendChild(box);
      document.body.appendChild(back);

      function done(answer) {
        document.removeEventListener("keydown", onKey, true);
        back.remove();
        if (opener && opener.focus) opener.focus();
        resolve(answer);
      }
      function onKey(ev) {
        if (ev.key === "Escape") { ev.preventDefault(); done(false); }
        else if (ev.key === "Tab") {
          var first = no, last = yes;
          if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
          else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
        }
      }
      document.addEventListener("keydown", onKey, true);
      back.addEventListener("mousedown", function (ev) { if (ev.target === back) done(false); });
      no.addEventListener("click", function () { done(false); });
      yes.addEventListener("click", function () { done(true); });
      (opts.danger ? no : yes).focus();
    });
  };
  global.csAsk = function (opts) {
    if (global.csConfirm) return global.csConfirm(opts || {});
    return Promise.resolve(window.confirm((opts && (opts.message || opts.title)) || "Are you sure?"));
  };
  global.csPrompt = function (opts) {
    opts = opts || {};
    return new Promise(function (resolve) {
      var id = "cs-dlg-" + ++seq;
      var opener = document.activeElement;
      var back = document.createElement("div");
      back.className = "cs-dlg-back";
      var box = document.createElement("div");
      box.className = "cs-dlg";
      box.setAttribute("role", "dialog");
      box.setAttribute("aria-modal", "true");
      box.setAttribute("aria-labelledby", id + "-t");
      var title = document.createElement("h2");
      title.id = id + "-t";
      title.className = "cs-dlg-title";
      title.textContent = opts.title || "Enter a value";
      var msg = document.createElement("p");
      msg.className = "cs-dlg-msg";
      msg.textContent = opts.message || "";
      var input = document.createElement("input");
      input.className = "cs-dlg-input";
      input.type = opts.inputType || "text";
      if (opts.placeholder) input.placeholder = opts.placeholder;
      if (opts.defaultValue != null) input.value = opts.defaultValue;
      var err = document.createElement("p");
      err.className = "cs-dlg-field-err";
      err.hidden = true;
      var row = document.createElement("div");
      row.className = "cs-dlg-actions";
      var no = document.createElement("button");
      no.type = "button";
      no.className = "cs-dlg-btn";
      no.textContent = opts.cancelLabel || "Cancel";
      var yes = document.createElement("button");
      yes.type = "button";
      yes.className = "cs-dlg-btn cs-dlg-primary";
      yes.textContent = opts.confirmLabel || "OK";
      row.appendChild(no);
      row.appendChild(yes);
      box.appendChild(title);
      if (opts.message) box.appendChild(msg);
      box.appendChild(input);
      box.appendChild(err);
      box.appendChild(row);
      back.appendChild(box);
      document.body.appendChild(back);

      function done(answer) {
        document.removeEventListener("keydown", onKey, true);
        back.remove();
        if (opener && opener.focus) opener.focus();
        resolve(answer);
      }
      function onKey(ev) {
        if (ev.key === "Escape") { ev.preventDefault(); done(null); }
        else if (ev.key === "Tab") {
          var first = input, last = yes;
          if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
          else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
        }
      }
      function submit() {
        var val = input.value;
        if (opts.required && !String(val || "").trim()) {
          err.textContent = opts.requiredMessage || "This field is required.";
          err.hidden = false;
          input.classList.add("invalid");
          input.focus();
          return;
        }
        done(val);
      }
      input.addEventListener("input", function () {
        err.hidden = true;
        input.classList.remove("invalid");
      });
      input.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter") { ev.preventDefault(); submit(); }
      });
      document.addEventListener("keydown", onKey, true);
      back.addEventListener("mousedown", function (ev) { if (ev.target === back) done(null); });
      no.addEventListener("click", function () { done(null); });
      yes.addEventListener("click", submit);
      setTimeout(function () { input.focus(); if (input.select && input.type !== "date") input.select(); }, 0);
    });
  };
  global.csToast = function (msg, kind) {
    if (!msg) return;
    if (window.frappe && typeof frappe.show_alert === "function") {
      frappe.show_alert({ message: msg, indicator: kind === "red" ? "red" : "green" });
      return;
    }
    var el = document.createElement("div");
    el.className = "cs-dlg";
    el.style.cssText = "position:fixed;top:72px;right:24px;z-index:6200;min-width:240px;padding:12px 14px;";
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 3200);
  };
  global.csFlash = function (msg, kind) {
    try { sessionStorage.setItem("cs_flash", JSON.stringify({ msg: msg, kind: kind || "green" })); } catch (e) {}
  };
  function consumeCsFlash() {
    try {
      var raw = sessionStorage.getItem("cs_flash");
      if (!raw) return;
      sessionStorage.removeItem("cs_flash");
      var d = JSON.parse(raw);
      var show = function () { global.csToast(d.msg, d.kind); };
      if (window.frappe && frappe.show_alert) show();
      else if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { setTimeout(show, 200); });
      else setTimeout(show, 400);
    } catch (e) {}
  }
  consumeCsFlash();
})(window);
